import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ReportDetailed } from "@shared/interfaces/ReportsFiles";
import ReportContentJson from "@pages/Report/components/ReportContentJson";
import ErrorReport from "@pages/Error/ErrorReport";
import ReportPublicHeader from "@pages/Report/components/ReportPublicHeader";
import { MapProvider } from "@shared/components/Mapbox/MapContext";
import MapBox from "@shared/components/Mapbox/Mapbox";
import { useReport } from "@utils/useReports";

const ReportPublicPage: React.FC = () => {
  const [reportResult, setReportResult] = useState<ReportDetailed>();

  const { reportId } = useParams<{ reportId: string }>();

  const [unauthorized, setUnauthorized] = useState(false);
  const { getPublicReport } = useReport();

  const handleReportReceive = async () => {
    try {
      if (!reportId) return;
      const report = await getPublicReport(reportId);

      setReportResult(report);
    } catch (error) {
      console.error(error);
      setUnauthorized(true);
    }
  };

  useEffect(() => {
    handleReportReceive();
  }, []);

  if (unauthorized) return <ErrorReport />;

  return (
    <div>
      {reportResult && (
        <>
          <ReportPublicHeader />
          {reportResult?.geojson_data && (
            <div className="h-[250px] w-full">
              <MapProvider>
                <MapBox
                  originalGeoJson={reportResult?.geojson_data}
                  isEditing={false}
                />
              </MapProvider>
            </div>
          )}
          <ReportContentJson
            template_name={reportResult.template_name}
            created_at={reportResult.created_at}
            initialContent={reportResult.content}
            initialTitle={reportResult.name}
            canComment={false}
          />
        </>
      )}
    </div>
  );
};

export default ReportPublicPage;
